import { useDeviceType, Spinner } from '@cian/ui-kit';
import { clsx as cx } from 'clsx';
import * as React from 'react';

import * as styles from './GeoSuggestMobile.css';
import { IGeoSuggestProps } from '../../types';
import { GeoSuggestModal } from '../GeoSuggestModal';
import { LocationButton } from '../LocationButton';

export const GeoSuggestMobile: React.FC<IGeoSuggestProps> = ({
  value,
  selectedItem,
  onValueChange,
  placeholder,
  loading,
  disabled,
  onGetGeolocation,
  ...props
}) => {
  const deviceType = useDeviceType();
  const [isOpen, setOpen] = React.useState<boolean>(false);

  const handleClose = React.useCallback(() => {
    setOpen(false);
    onValueChange('');
  }, [onValueChange]);

  const handleGetGeolocation = async () => {
    const locationName = await onGetGeolocation();
    onValueChange(locationName);
    setOpen(true);
  };

  return (
    <>
      <div className={styles['button-wrapper']}>
        <button
          className={cx(
            styles['button'],
            styles[`button--${deviceType}`],
            !selectedItem && styles['button--placeholder'],
          )}
          type="button"
          disabled={disabled}
          onClick={() => setOpen(true)}
        >
          <span className={styles['button-text']}>{selectedItem?.displayName || placeholder}</span>
        </button>
        <div className={styles['location-button-wrapper']}>
          {loading && (
            <div className={styles['spinner']}>
              <Spinner />
            </div>
          )}
          {!loading && <LocationButton onClick={handleGetGeolocation} />}
        </div>
      </div>
      <GeoSuggestModal
        isOpen={isOpen}
        onClose={handleClose}
        value={value}
        loading={loading}
        disabled={disabled}
        placeholder={placeholder}
        onValueChange={onValueChange}
        onGetGeolocation={onGetGeolocation}
        {...props}
      />
    </>
  );
};
